angular.module('logbook')
  .controller('reminder-query', ['$scope', '$http', '$interval', '$timeout', '$location', '$q', '$sce', 'reminderStatusFactory', 'tagStyle',
      function($scope, $http, $interval, $timeout, $location, $q, $sce, reminderStatusFactory, tagStyle) {
        $scope.reminderStatusFactory = reminderStatusFactory;

        $scope.expandedReminders = {};
        $scope.textOverflows = {};
        $scope.recentQuery = 0;
        $scope.queryExecuting = 0;
        $scope.remindersRendered=0;
        $scope.resultFormat = '';
        $scope.queryFormat = '';
        $scope.validSorts = [
           { id: 'status', desc: 'Status'},
           { id: 'startTime', desc: 'Start Time'},
           { id: 'endTime', desc: 'End Time'},
           { id: 'updated', desc: 'Last Updated At'},
           { id: 'request', desc: 'Reminder'}
        ];
        
        $scope.$sce = $sce;

        
        $scope.cancelQuery = function()
        {
           if( $scope.getReminderCanceller )
           {
              $scope.getReminderCanceller.promise.suppressErrorFlag = true;
              $scope.getReminderCanceller.resolve();
              
           }
        };

        $scope.getReminders = function(tableState, zzz, append) {
           $scope.cancelQuery();
           $scope.query.size = 25;
           if( append )
           {
              $scope.query.page++;
           }
           else
           {
              $scope.query.page = 0;
              $scope.remindersRendered=0;
              delete $scope.page;
           }

              
           if( $scope.getReminderHandle )
           {
              var canceled = $timeout.cancel($scope.getReminderHandle);
              if( canceled )
                 console.log("canceled get requests");
           }
           
           $scope.getReminderCanceller = $q.defer();

           if( !append )
              $scope.queryExecuting++;

           $scope.recentQuery++;
           
           console.log("getting requests");
           $scope.getReminderHandle = $timeout(function() {
              $http.get('/api/reminders', {
                 params: $scope.query,
                 timeout: $scope.getReminderCanceller.promise
              })
              .then(function(result) {
                 if( result.data.page.number < result.data.page.totalPages-1)
                    $scope.getReminders($scope.tableState, null, true);

                 $scope.page = result.data.page;
                 if( !append )
                    $scope.reminderList = [];

                 $scope.reminderList = $scope.reminderList.concat(result.data._embedded.reminders);
                 $scope.remindersRendered += result.data._embedded.reminders.length;

                 if( !append )
                    $scope.queryExecuting--;
                 $timeout(function() {
                    $timeout(function() {
                       $scope.checkTextOverflows(result.data._embedded.reminders);
                    }, 0);
                 }, 0);
                 $timeout(function() {
                    $scope.recentQuery--;
                 }, 250);
              }, function(error) {
                 if( !append )
                    $scope.queryExecuting--;
                 $scope.recentQuery--;
              });
           });
        };
        
        
        $scope.checkTextOverflows = function(reminders)
        {
           reminders.forEach(function(reminder) {
              $('#reminder-div-'+reminder.id).find('img').on('load', function() {
                 $timeout(function() {
                    $scope.textOverflows[reminder.id] = $scope.overflows(reminder.id);
                 });
              });
              $scope.textOverflows[reminder.id] = $scope.overflows(reminder.id);
           });
        };
        
        $scope.overflows = function(reminder)
        {
           return $('#reminder-div-'+reminder).prop('scrollHeight')
              > $('#reminder-div-'+reminder).prop('clientHeight');
        };
        
        $scope.toggleExtraText = function(reminder)
        {
           var isExpanded = $scope.expandedReminders[reminder.id];
           $('#reminder-show-toggle-'+reminder.id).text(isExpanded ? 'Show More' : 'Show Less');
           $('#reminder-div-'+reminder.id).css('max-height', isExpanded ? '6em' : '');
           $scope.expandedReminders[reminder.id] = !isExpanded;
        };

        $scope.showReminderDetail = function(note) {
           $location.url('/reminder-detail').search('reminder', note._links.self.href);
        };

        $scope.updated = function()
        {
           $scope.getReminders();
        };
        
        $scope.displayReminder = function(reminder, index) {
           $location.url('/reminder-detail')
              .search('reminder', reminder._links.self.href)
              .search('query', JSON.stringify($scope.query))
              .search('query-format', $scope.queryFormat)
              .search('result-format', $scope.resultFormat)
              .search('index', index);
        }
        
        $scope.getReminderClass = function(reminder)
        {
           var style = tagStyle.findTagStyle(reminder.tagValues) || [];
           style.push('reminder-table-reminder');
           return style;
        };
        
        $scope.toggleEmphasized = function(reminder) {
           $http.patch(reminder._links.self.href,
                 {'emphasized':!reminder.emphasized}).then(function(response) {
                 reminder.emphasized = !reminder.emphasized;
              });
        };

}]);